<template>
  <v-app>
    <v-toolbar color="green lighten-2" app>
      <v-toolbar-title v-text="title"></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-side-icon></v-toolbar-side-icon>
    </v-toolbar>
    <v-content>
      <v-container fluid ma-0 pa-0 fluid ma-0 pa-0 fill-height>
        <v-container>
  <v-card>
    <v-tabs
      v-model="tab"
      background-color="primary"
      dark
    >
      <v-tab>Приложение к акту ЛПО</v-tab>
    </v-tabs>
    <v-tabs-items>
      <v-tab-item key="Приложение к акту ЛПО">
          <prillpo />
      </v-tab-item>
    </v-tabs-items>
  </v-card>
        </v-container>
      </v-container>
    </v-content>

     <v-bottom-nav app
      active.sync=1
      value="true"
      absolute
      color="green"
    >
    </v-bottom-nav>
  </v-app>
</template>
<script>
import Prillpo from '../components/prillpo'
export default {
  name: 'dn61',
  components: {
    Prillpo
  },
  data () {
    return {
      tab: null,
      title: "ФБУ РОСЛЕСОЗАЩИТА. ОТДЕЛ ДНиГИС Красноярского края"
    }
  },
  mounted: function () {
    
  },
  computed: {
  },
  methods: {
  },
  watch: {
  }
}
</script>